import mapValues from "lodash/mapValues";
import { DetailsPanelData } from "PFApp/booking/components/details_panel";
import { SidePanelType, useSidePanelsActions, useSidePanelsStore } from "PFApp/stores/side_panels_store";
import { DependencyList, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

type UseUpdateDetailsPanelsData = {
  data: Partial<DetailsPanelData>;
  dependencies: DependencyList;
};

export const useUpdateDetailsPanelsData = ({ data, dependencies }: UseUpdateDetailsPanelsData) => {
  const openPanelsKeys = useSidePanelsStore(
    useShallow((state) =>
      state.panels.filter(({ key }) => key.startsWith(SidePanelType.BookingDetails)).map(({ key }) => key)
    )
  );
  const { updatePanelsData } = useSidePanelsActions<Partial<DetailsPanelData>>();

  useEffect(() => {
    updatePanelsData(SidePanelType.BookingDetails, data);
    return () =>
      updatePanelsData(
        SidePanelType.BookingDetails,
        mapValues(data, () => undefined)
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, openPanelsKeys, updatePanelsData]);
};
